
import { Hero } from "@/components/Hero";
import { Stories } from "@/components/Stories";
import { Courses } from "@/components/Courses";
import { FacultyCourses } from "@/components/FacultyCourses";
import { WhyUs } from "@/components/WhyUs";
import { News } from "@/components/News";
import { Partners } from "@/components/Partners";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { SEOHead } from "@/components/SEOHead";
import { ScrollToTop } from "@/components/ScrollToTop";
import { useI18n } from "@/i18n/LanguageContext";

const HOME_KEYWORDS: Record<string, string> = {
  hy: "ծրագրավորում, կիբերանվտանգություն, web development, IT ուսուցում, Հայաստան, programming courses, նախազորակոչային, ակադեմիա, Java, Python, C++, C#, HTML, CSS, JavaScript, React, AI դասընթաց, QA testing, դասընթացներ, ծրագրավորման կրթություն, IT ակադեմիա",
  ru: "курсы программирования Ереван, кибербезопасность курсы Армения, IT академия, обучение программированию, Java, Python, C++, C#, JavaScript, React, курс искусственного интеллекта, QA тестирование, Global IT Academy",
  en: "programming courses Armenia, cybersecurity courses Yerevan, IT academy, learn to code, Java, Python, C++, C#, JavaScript, React, AI course, QA testing, Global IT Academy",
};

const SITE = "https://globalitacademy.am";
const HOME_ALTERNATES = [
  { hreflang: "hy", href: `${SITE}/` },
  { hreflang: "ru", href: `${SITE}/?lang=ru` },
  { hreflang: "en", href: `${SITE}/?lang=en` },
  { hreflang: "x-default", href: `${SITE}/` },
];
const OG_LOCALES: Record<string, string> = { hy: "hy_AM", ru: "ru_RU", en: "en_US" };

const Index = () => {
  const { t, locale } = useI18n();
  const ogLocale = OG_LOCALES[locale] ?? "hy_AM";

  return (
    <>
      <SEOHead
        title={t.seo.homeTitle}
        description={t.seo.homeDescription}
        // Each language version is self-canonical; Armenian stays on the bare root URL.
        path={locale === "hy" ? "/" : `/?lang=${locale}`}
        keywords={HOME_KEYWORDS[locale] ?? HOME_KEYWORDS.hy}
        contentType="website"
        locale={ogLocale}
        alternateLocales={Object.values(OG_LOCALES).filter((l) => l !== ogLocale)}
        hreflangAlternates={HOME_ALTERNATES}
        image="https://globalitacademy.am/lovable-uploads/6f79c514-8a5e-451f-a5ed-e876d25c53e0.png"
      />
      <div className="min-h-screen bg-background font-sans">
        <Hero />
        <Stories />
        <div className="defer-render">
          <Courses />
        </div>
        <div className="defer-render">
          <FacultyCourses />
        </div>
        <div className="defer-render">
          <WhyUs />
        </div>
        <div className="defer-render">
          <News />
        </div>
        <div className="defer-render">
          <Partners />
        </div>
        <div className="defer-render">
          <FAQ />
        </div>
        <div id="contact" className="defer-render scroll-mt-20">
          <Contact />
        </div>
        <ScrollToTop />
      </div>
    </>
  );
};

export default Index;
